export enum VIEW {
  CIP_GENERATION = '/generarcip',
  CIP_REPORT = '/reportecip',
  USERS = '/usuarios',
  HOME = '/',
  CREATE_USER = '/usuarios/crear'
}
